import React from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  CardTitle,
} from "reactstrap"
export default function Password(props) {
  const { userData } = props

  return (
    <Col lg={6}>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Security Details</CardTitle>

          <Form>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Username</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {`${userData?.first_name} ${userData?.last_name}` ?? "-"}
                </p>
              </Col>
            </div>

            <div className="row mb-2">
              <Col xs={12} sm={12} md={12} lg={12}>
                <button
                  className="btn btn-light w-md form-control"
                  type="button"
                >
                  Forgot Password - SMS
                </button>
              </Col>
            </div>
            <div className="row mb-2">
              <Col xs={12} sm={12} md={12} lg={12}>
                <button
                  className="btn btn-primary w-md form-control"
                  type="button"
                >
                  Forgot Password - Email
                </button>
              </Col>
            </div>
            <div className="row mb-2">
              <Col xs={12} sm={12} md={12} lg={12}>
                <button
                  className="btn btn-success w-md form-control"
                  type="button"
                >
                  Forgot Password - Telegram
                </button>
              </Col>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  )
}
